import { render, staticRenderFns } from "./ParticipantDashboardLayout.vue?vue&type=template&id=dacc211e&scoped=true&"
import script from "./ParticipantDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./ParticipantDashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantDashboardLayout.vue?vue&type=style&index=0&id=dacc211e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacc211e",
  null
  
)

export default component.exports